import React, { ReactNode } from 'react';
import { Button } from '@mui/material';

interface Props {
  readonly onClick: () => void;
  readonly children?: ReactNode;
}

/**
 * A component to render a smaller button below a `LoginInput`.
 */
export function AlternateActionButton({ children, onClick }: Props) {
  return (
    <div>
      <Button
        variant="text"
        size="small"
        fullWidth={false}
        sx={{ float: 'right', bgcolor: 'transparent' }}
        onClick={onClick}
      >
        {children}
      </Button>
    </div>
  );
}
